import { getUrlHostname } from '@helsenorge/core-utils/url';
import { getHelsenorgeUrl } from '@helsenorge/framework-utils/hn-proxy-service';

export const getOrchestratorWsUrl = (): string => {
  if (import.meta.env.MODE === 'development' && import.meta.env.VITE_ORCHESTRATOR_WS_URL) {
    return import.meta.env.VITE_ORCHESTRATOR_WS_URL;
  }
  return `wss://${getUrlHostname(getHelsenorgeUrl())}`;
};
